/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  function initTeeinblueAddToCart() {
    const wrappers = document.querySelectorAll(
      'product-form[data-teeinblue-bypass="true"]'
    );

    wrappers.forEach((wrapper) => {
      const form = wrapper.querySelector('form[action*="/cart/add"]');

      if (!form || form.dataset.teeinblueCartFix === 'true') return;

      form.dataset.teeinblueCartFix = 'true';

      form.addEventListener(
        'submit',
        async function(event) {
          event.preventDefault();
          event.stopImmediatePropagation();

          const submitButton =
            event.submitter ||
            form.querySelector('[type="submit"][name="add"]');

          const customizationId = form.querySelector(
            '[name="properties[_customization_id]"]'
          )?.value;

          if (!customizationId) {
            alert(
              'Please finish creating and selecting your portrait before adding it to your cart.'
            );
            return;
          }

document.dispatchEvent(
  new CustomEvent('theme:cart:add', {
    detail: {
      button: submitButton
    },
    bubbles: false
  })
);

          if (submitButton) submitButton.disabled = true;

          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                Accept: 'application/json'
              },
              body: new FormData(form)
            });

            const result = await response.json();

            if (!response.ok) {
              throw new Error(
                result.description ||
                result.message ||
                'Unable to add this item to the cart.'
              );
            }

const cartItems = document.querySelector('cart-items');
const cartDrawer = document.querySelector('cart-drawer');

if (cartItems && typeof cartItems.getCart === 'function') {
  await cartItems.getCart();
}

if (cartDrawer && typeof cartDrawer.openCartDrawer === 'function') {
  cartDrawer.openCartDrawer();
}

if (submitButton) submitButton.disabled = false;

          } catch (error) {
            console.error('Teeinblue Add to Cart error:', error);

            alert(
              'We were unable to add your customized tee to the cart. Please try again.'
            );

            if (submitButton) submitButton.disabled = false;
          }
        },
        true
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTeeinblueAddToCart);
  } else {
    initTeeinblueAddToCart();
  }

  document.addEventListener(
    'shopify:section:load',
    initTeeinblueAddToCart
  );

 // Lock accelerated checkout until a Teeinblue portrait is completed
function initTeeinblueCheckoutGate() {
  const wrapper = document.querySelector(
    'product-form[data-teeinblue-bypass="true"]'
  );

  // Teeinblue/Broadcast may not be ready yet
  if (!wrapper) {
    setTimeout(initTeeinblueCheckoutGate, 500);
    return;
  }

  // Prevent multiple copies of this watcher
  if (wrapper.dataset.teeinblueCheckoutGate === 'true') return;

  wrapper.dataset.teeinblueCheckoutGate = 'true';

  const updateCheckoutState = () => {
    // Re-find these every time because Teeinblue adds/updates them asynchronously
    const form = wrapper.querySelector(
      'form[action*="/cart/add"]'
    );

    const customizationInput = form?.querySelector(
      '[name="properties[_customization_id]"]'
    );

    const portraitReady =
      !!customizationInput?.value?.trim();

    const dynamicCheckout =
      wrapper.querySelector('.shopify-payment-button') ||
      document.querySelector('.shopify-payment-button');

    // Hide accelerated checkout until a real customization ID exists
    if (dynamicCheckout) {
      dynamicCheckout.style.display = portraitReady ? '' : 'none';
    }

    // Customer-facing message
    let message = wrapper.querySelector(
      '[data-teeinblue-checkout-message]'
    );

    if (!message && !portraitReady && form) {
      message = document.createElement('div');
      message.setAttribute(
        'data-teeinblue-checkout-message',
        'true'
      );

      message.innerHTML =
        '<strong>Finish your portrait to continue</strong><br>' +
        'Upload your pet photo and create your custom portrait before checkout.';

      message.style.marginTop = '12px';
      message.style.marginBottom = '12px';
      message.style.padding = '12px';
      message.style.textAlign = 'center';

      const submitButton = form.querySelector(
        '[type="submit"][name="add"]'
      );

      if (submitButton && submitButton.parentElement) {
        submitButton.parentElement.insertAdjacentElement(
          'afterend',
          message
        );
      }
    }

    if (message) {
      message.style.display = portraitReady ? 'none' : '';
    }
  };

  // Run immediately
  updateCheckoutState();

  // Catch Teeinblue adding/replacing form elements
  const observer = new MutationObserver(updateCheckoutState);

  observer.observe(wrapper, {
    subtree: true,
    childList: true,
    attributes: true
  });

  // Also catch JavaScript changes to input.value,
  // which do not always trigger MutationObserver
  setInterval(updateCheckoutState, 500);
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initTeeinblueCheckoutGate
  );
} else {
  initTeeinblueCheckoutGate();
}

document.addEventListener(
  'shopify:section:load',
  initTeeinblueCheckoutGate
);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();